import { Autocomplete, TextField } from "@mui/material";
import { Controller, Control, FieldError } from "react-hook-form";
import { Funder } from "@/interfaces/opportunities";

interface FunderFieldProps {
  control: Control<any>;
  autocompleteProps: any;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onFunderChange?: (funder: Funder | null) => void;
  error?: FieldError;
  currentFunder?: Funder | null;
}

export const FunderField: React.FC<FunderFieldProps> = ({
  control,
  autocompleteProps,
  searchQuery,
  onSearchChange,
  onFunderChange,
  error,
  currentFunder,
}) => {
  return (
    <Controller
      control={control}
      name={currentFunder !== undefined ? "funder_uuid" : "funder"}
      rules={{ required: "This field is required" }}
      render={({ field, fieldState: { error: fieldError } }) => (
        <Autocomplete
          {...autocompleteProps}
          value={
            currentFunder !== undefined ? currentFunder : field.value ?? null
          }
          onInputChange={(_, value) => onSearchChange(value)}
          getOptionLabel={(option: Funder) => option?.name || ""}
          isOptionEqualToValue={(option: Funder, value: Funder) =>
            option?.uuid === value?.uuid
          }
          noOptionsText="Start typing funder name..."
          onChange={(_, value: Funder | null) => {
            if (currentFunder !== undefined) {
              // Edit mode: store UUID
              field.onChange(value?.uuid || "");
            } else {
              // Create mode: store entire funder object
              field.onChange(value);
            }
            onFunderChange?.(value);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Funder"
              margin="normal"
              variant="outlined"
              error={!!(error || fieldError)}
              helperText={error?.message || fieldError?.message || ""}
            />
          )}
        />
      )}
    />
  );
};
